/**
 * Core / Plugin: Web Components Vuex State (empty)
 * -----------------------------------------------------------------------------
 * Empty file used to replace file if web components Vuex state are disabled.
 *
 */
/* eslint-disable no-empty-function */

export default () => {
  return () => {}
}
